import { getOrderRelatedShowtimeById } from '../../order/selectors/showtimes/get-order-related-showtime-by-id';
export const sortOrderShowtimes = (showtimes) => {
    return [...showtimes].sort((a, b) => {
        const showtimeA = getOrderRelatedShowtimeById(a.showtimeId);
        const showtimeB = getOrderRelatedShowtimeById(b.showtimeId);
        if (!showtimeA || !showtimeB)
            return 0;
        return new Date(showtimeA.schedule.startsAt).getTime() - new Date(showtimeB.schedule.startsAt).getTime();
    });
};
